import { defineStore } from 'pinia'
import { useAuthStore } from './auth-store'

export const useUserStore = defineStore('user', {
  state: () => {
    const authStore = useAuthStore()
    const userInfo = authStore.user

    return {
      userName: userInfo?.fullname || '飛網世界',
      email: userInfo?.email || 'service@flynetworld.com',
      memberSince: userInfo?.createdAt
        ? new Date(userInfo.createdAt).toLocaleDateString('zh-TW', {
            timeZone: 'Asia/Taipei',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })
        : '01/01/2025',
      pfp: userInfo?.avatar || '/images/default-avatar.png',
      is2FAEnabled: false,
    }
  },

  actions: {
    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },

    changeUserName(userName: string) {
      this.userName = userName
    },

    updateUserInfo() {
      const authStore = useAuthStore()
      const userInfo = authStore.user
      console.log('userInfo', userInfo)

      if (userInfo) {
        this.userName = userInfo.fullname
        this.email = userInfo.email
        this.memberSince = new Date(userInfo.createdAt).toLocaleDateString('zh-TW', {
          timeZone: 'Asia/Taipei',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
        this.pfp = userInfo.avatar || '/images/default-avatar.png'
      }
    },
  },
})
